export const FilterModal = {
  props: ['title', 'items', 'initialSelection', 'optionsCount', 'component', 'lang'],
  data: function() {
    return {
      searchQuery: '',
      selected: (this.initialSelection ? JSON.parse(JSON.stringify(this.initialSelection)) : [])
    };
  },
  // Teleport the overlay to <body> so its z-index competes in the root
  // stacking context. Left in place, ancestors that create their own stacking
  // context (e.g. the sticky filter column, position: sticky) trap it below
  // later-DOM positioned elements like the vehicle cards. Vue keeps patching
  // the moved root element and removes it from its current parent on destroy,
  // so no extra cleanup is needed.
  mounted: function() {
    document.body.appendChild(this.$el);
  },
  template: `
  <div @click.self="close" class="z-[9999] fixed top-0 bottom-0 right-0 left-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
    <div class="bg-white w-full max-w-4xl max-h-[90vh] rounded-lg shadow-xl flex flex-col overflow-hidden">
      <!-- Header -->
      <div class="flex items-center justify-between p-6 border-b">
        <h2 class="text-2xl font-bold text-gray-800">{{ title }}</h2>
        <button @click="close" class="text-gray-500 hover:text-gray-700 p-2 border-0 bg-transparent cursor-pointer">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Search -->
      <div class="p-4 bg-gray-50 border-b">
        <div class="relative">
          <input type="text" v-model="searchQuery" :placeholder="lang === 'fr_CA' ? 'Rechercher...' : 'Search...'"
            class="w-full pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
            style="padding-left: 2.5rem !important;">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>
      </div>

      <!-- Options Grid -->
      <div class="flex-1 overflow-y-auto p-6 custom-v-scroll">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          <label v-for="item in filteredItems" :key="item" 
            :class="['flex items-center justify-between p-3 border rounded-md cursor-pointer transition-all duration-200', 
                     isSelected(item) ? 'bg-primary border-primary text-white shadow-md' : 'bg-white hover:bg-gray-50 border-gray-200 text-gray-700']">
            <div class="flex items-center">
              <input type="checkbox" :value="item" v-model="selected" @change="update" class="hidden">
              <span class="font-semibold capitalize text-sm text-left">{{ item }}</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="text-[10px] font-bold opacity-80" v-if="getCount(item) > 0">({{ getCount(item) }})</span>
              <svg v-if="isSelected(item)" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
          </label>
        </div>
        <div v-if="filteredItems.length === 0" class="text-center py-12 text-gray-500">
           {{ lang === 'fr_CA' ? 'Aucune option trouvée' : 'No options found' }}
        </div>
      </div>

      <!-- Footer -->
      <div class="p-6 border-t bg-gray-50 flex justify-center">
        <button @click="close" class="bg-primary text-white px-12 py-3 rounded-md font-bold uppercase tracking-wider hover:bg-primary-dark transition-colors shadow-lg border-0 cursor-pointer">
          {{ lang === 'fr_CA' ? 'Voir les résultats' : 'View Results' }}
        </button>
      </div>
    </div>
  </div>
  `,
  computed: {
    filteredItems: function() {
      var self = this;
      if (!this.searchQuery) return this.items;
      return this.items.filter(function(item) {
        return item.toLowerCase().indexOf(self.searchQuery.toLowerCase()) !== -1;
      });
    }
  },
  methods: {
    isSelected: function(item) {
      return this.selected.indexOf(item) !== -1;
    },
    getCount: function(item) {
      return this.optionsCount ? (this.optionsCount[item] || 0) : 0;
    },
    update: function() {
      this.$emit('updatechecked', {
        component: this.component,
        selected: this.selected
      });
    },
    close: function() {
      this.$emit('close');
    }
  },
  watch: {
    initialSelection: {
      immediate: true,
      handler: function(newVal) {
        this.selected = (newVal ? JSON.parse(JSON.stringify(newVal)) : []);
      }
    }
  }
};
